module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SX - Sint Maarten.c0dc2536.svg";